export default {
    areatree: {},
    classcode: {},
    submitHospital: {},
    areahospital: {},
    createHosInfo: {}
}
